import { createAsyncThunk } from '@reduxjs/toolkit';

import type { IAuthLoginVerifyOtpCodeBody } from '@/Module/Auth/Model/ApiModel';
import type { IInoAuth } from '@/Module/Auth/Model/DataModel';
import { InoAuthService } from '@/Module/Auth/Service';

export const authLoginVerifyOtpCodeAction = createAsyncThunk<IInoAuth, IAuthLoginVerifyOtpCodeBody>(
  'auth/loginVerifyOtpCode',
  async (req, { signal, rejectWithValue }) => {
    return InoAuthService.loginVerifyOtpCode(req, signal)
      .then(
        ({
          data: {
            data: { data },
          },
        }) => data,
      )
      .catch(rejectWithValue);
  },
);
